import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	confirmation: {
		padding: 20,
		minHeight: 'unset',
	},
});
